import { createElement, Fragment } from "@wordpress/element";
/**
 * Internal dependencies
 */
import AdvancedControls from './advanced-controls-panel';
import PositionControls from './position-controls-panel';
import { default as InspectorControls } from '../inspector-controls';
import SettingsTabHint from './settings-tab-hint';
const SettingsTab = ({
  showAdvancedControls = false
}) => createElement(Fragment, null, createElement(InspectorControls.Slot, null), createElement(PositionControls, null), showAdvancedControls && createElement("div", null, createElement(AdvancedControls, null)), createElement(SettingsTabHint, null));
export default SettingsTab;
//# sourceMappingURL=settings-tab.js.map